export type Prestation = any

export interface PrestationData {
	_class: string
	prestationId: string
	liheId: string
	liheName: string
	pictos: string
	accomodationName: string
	accomodationDescriptionShort: string
	orientation: string
	numberOfBedrooms: string
	accomodationDescription: string
	zeroNom: string
	capacity: number
	picturesAccomodation: IPicturesAccomodation[]
	criterias: string[]
	departementId: string
	countryId: string
	regionId: string
	departement: string
	country: string
	region: string
	station: string
	stationId: string
	criteriasSet: Record<string, unknown> // This represents an empty object
	variants?: Variant[]
}

export interface Variant {
	liheId: string
	liheName: string
	crossedPrice: number
	pricePerLogement: number
	pricePerPerson: number
	maxPromo: number
	duration: number
	codePackage: string
	startDate: string
	endDate: string
	prestId: string
	prestIdSource: string
	prestIdFusion: string
	prestName: string
	prestDesc: string
	maxCapacity: number
	quantity: number
	skipass: number
	productPageUrl: string
	fee: number
	nbBedRoom: number
	nbRoom: number
	averageRatingPerLihe: number
	reviewNumberPerLihe: number
	id: string
	totalMaxCapacity: number
	pricePerLogementWithoutFee?: number
	paymentCondition?: number
	cancelationUntil?: string
	pvFlex?: string
}
export interface IPicturesAccomodation {
	img: string
	imgXL: string
	imgSmall: string
	imgMedium: string
	imgLarge: string
	imgNumber: number
}

export interface IPicturesAccomodationExtended {
	img: string
	imgXL: string
	imgSmall: string
	imgMedium: string
	imgLarge: string
	imgNumber: number
	section: string
}

export interface IReservation {
	quantity: number
	prestationsIds: string[]
	prestationsNames: string[]
	totalPrice: string
	beginDate: string
	endDate: string
	duration: number
	liheId: string
	liheName: string
	region: string
	station: string
}

export interface ISelectedPrestation {
	prestation: {
		liheId: string
		liheName: string
		pricePerLogement: number
		pricePerLogementWithoutFee: number
		pricePerPerson: number
		pricePerPersonWithoutFee: number
		duration: number
		codePackage: string
		startDate: string
		endDate: string
		prestId: string
		prestIdSource: string
		prestIdFusion: string
		prestName: string
		prestDesc: string
		maxCapacity: number
		quantity: number
		skipass: number
		productPageUrl: string
		priceDiff: number
		fee: number
		nbBedRoom: number
		nbRoom: number
		averageRatingPerLihe: number
		reviewNumberPerLihe: number
		id: string
		totalMaxCapacity: number
	}
	quantity: number
}

export interface PageMeta {
	id: string
	category: string
	author: string
	tags: string[]
	updateDate: string
	creationDate: string
	site: string
	originRefId: string
	duplicates: {
		ProductPage: string[]
	}
	urlLabel: string
	urlPath: string
	type: string
	locale: string
	level: number
	order: number
	seoLinkTargets: {
		id: string
		rank: number
		order: number
		crawlerLabel: string
		urlPath: string
	}[]
	schemas: string[] // This array contains JSON strings that could potentially be parsed into a more complex structure
	breadCrumbs: BreadCrumb[]
	ratingData: {
		locationAverageRating: number
		surroundingsAverageRating: number
		equipementAverageRating: number
		valueForMoneyAverageRating: number
		globalAverage: number
		stationSurroundingAverage: number
		skiAreaAverage: number
		pageCurrentNum: number
		pageSize: number
		pageCount: number
		reviewsSize: number
		averageRatingMin: number
		averageRatingMax: number
		averageRating: {
			[key: string]: number
		}
	}
	generationStatus: string
	lastGeneration: string
}

export interface BreadCrumb {
	label: string
	level: number
	url: string
}


export interface PackageOffer {
    liheId: string;
    liheName: string;
    pricePerPerson: number;
    duration: number;
    codePackage: string;
    startDate: string;
    endDate: string;
    prestId: string;
    prestIdSource: string;
    prestIdFusion: string;
    zeroCode?: string;
    prestName: string;
    prestDesc: string;
    paymentCondition: number;
    cancelationUntil: string;
    maxCapacity: number;
    quantity: number;
    skipass: number;
    productPageUrl: string;
    fee: number;
    nbBedRoom: number;
    nbRoom: number;
    averageRatingPerLihe: number;
    reviewNumberPerLihe: number;
    id: string;
    pricePerLogement: number;
	priceAccommodationOnly?: number;
	crossedPrice?: number;
    maxPromo?: number;

}

export interface ISeAvailabilities {
    [packageId: string]: {
        [id: string]: PackageOffer;
    };
}

export interface Range {
	key: string;
	dates: { start: Date | null; end: Date | null }; // Allow null values here
	highlight: string;
}

export interface HashParams {
	BeginDate: string,
	EndDate: string,
	packCode: string, 
	season: string
}

export interface OriginInfo {
	name: string;
	parent?: string;
}

export enum Transport {
	FLIGHT = "FLIGHT",
	TRAIN = "TRAIN"
}

